import { CheckMark, Container, HiddenCheckbox, Label, LabelText, StyledCheckbox } from './CheckBox.styled'

interface CheckboxProps {
  label?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  id?: string
  name?: string
  'aria-invalid'?: boolean
  size?: 'small' | 'medium'
  className?: string
}

export const CheckBox: React.FC<CheckboxProps> = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  id,
  name,
  'aria-invalid': invalid,
  size = 'medium',
  className,
  ...props
}: CheckboxProps) => {
  return (
    <Container>
      <Label disabled={disabled}>
        <HiddenCheckbox
          type="checkbox"
          checked={checked}
          onChange={disabled ? undefined : onChange}
          disabled={disabled}
          id={id}
          name={name}
          aria-invalid={invalid}
          {...props}
        />

        <StyledCheckbox className={className} size={size} checked={checked} disabled={disabled} aria-invalid={invalid}>
          <CheckMark size={size} checked={checked} />
        </StyledCheckbox>
        {label && (
          <LabelText disabled={disabled} aria-invalid={invalid}>
            {label}
          </LabelText>
        )}
      </Label>
    </Container>
  )
}
